module.exports = __webpack_public_path__ + "img/yingjie.579912eb.jpg";